module.exports = __webpack_public_path__ + "img/A58A0908.40e8a900.jpg";